import { createSlice } from '@reduxjs/toolkit'
import createQueryString from 'src/utils/createQueryString'
import { getComments } from './commentSlice'
import axios from '../../api/index'
import { failed, success } from './snackSlice'
import { startLoading, stopLoading } from './loadingSlice'

export const ticketSlice = createSlice({
  name: 'tickets',
  initialState: { list: [] },
  reducers: {
    ticketsFetched: (state, { payload }) => {
      return { ...state, list: payload.list, status: payload.status }
    },

    selectedTicket: (state, { payload }) => ({ ...state, selectedTicket: payload }),
  },
})

export const {
  ticketsFetched,
  selectedTicket,
} = ticketSlice.actions

export const getTickets = ({ first, after }) => (dispatch) => {
  dispatch(startLoading())
  axios.get(`ticket/?first=${first}&after=${after}`)
    .then((res) => {
      dispatch(stopLoading())
      dispatch(
        ticketsFetched({ list: res?.data.data }),
      )
    })
    .catch((e) => {
      dispatch(stopLoading())
      dispatch(failed(e?.response?.data?.message, ''))
      // dispatch(failed('مشکل در دریافت تیکت‌ها'))
    })
}

export const getTicket = (ticketId) => (dispatch) => {
  dispatch(startLoading())
  axios.get(`ticket/${ticketId}`)
    .then((res) => {
      dispatch(stopLoading())
      dispatch(
        selectedTicket({ selectedTicket: res?.data.data }),
      )
    })
    .catch((e) => {
      dispatch(stopLoading())
      console.error(e)
      dispatch(failed(e?.response?.data?.message, ''))
      // dispatch(failed('مشکل در دریافت تیکت‌ها'))
    })
}

export const getTicketsByStatus = (data) => (dispatch) => {
  dispatch(startLoading())
  axios.get('ticket', { params: createQueryString(data) })
    .then((res) => {
      dispatch(stopLoading())
      dispatch(
        ticketsFetched({ list: res?.data.data, status: data.status }),
      )
    })
    .catch((e) => {
      dispatch(stopLoading())
      console.error(e)
      dispatch(failed(e?.response?.data?.message, ''))
      // dispatch(failed('مشکل در دریافت تیکت‌ها'))
    })
}

export const addTicket = ({ question, file }, navigate) => (dispatch) => {
  dispatch(startLoading())

  const data = new FormData()
  data.append('ticket', JSON.stringify({ question }))
  if (file) data.append('file', file)

  axios.post('/ticket', data, {
    headers: {
      'Content-Type': 'multipart/form-data; boundary=<calculated when request is sent>',
    },
  })
    .then((res) => {
      console.log(res)
      dispatch(stopLoading())
      dispatch(success('تیکت جدید ساخته شد'))
      navigate(`../${res?.data?.data}`)
    })
    .catch((e) => {
      dispatch(stopLoading())
      console.error(e)
      dispatch(failed(e?.response?.data?.message, ''))
      // dispatch(failed('مشکل در افزودن تیکت جدید'))
    })
}

export const ask = (ticketId, message) => (dispatch) => {
  const { file, question } = message
  console.log(message)
  dispatch(startLoading())
  const data = new FormData()
  data.append('question', question)
  if (file) data.append('file', file)

  axios.post(`ticket/${ticketId}/ask`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
    .then(() => {
      dispatch(stopLoading())
      dispatch(getComments(ticketId))
    })
    .catch((e) => {
      dispatch(stopLoading())
      console.error(e)
      dispatch(failed(e?.response?.data?.message, ''))
      // dispatch(failed('مشکل در ارسال سوال'))
    })
}

export const answer = (message) => (dispatch) => {
  dispatch(startLoading())
  const data = new FormData()
  data.append('answer', message.answer)
  if (message.file) data.append('file', message.file)

  axios.post(`ticket/${message.id}/answer`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
    .then(() => {
      dispatch(stopLoading())
      dispatch(getTicketsByStatus(110))
      dispatch(getComments(message.id))
    })
    .catch((e) => {
      dispatch(stopLoading())
      console.error(e)
      dispatch(failed(e?.response?.data?.message, ''))
      // dispatch(failed('مشکل در ارسال سوال'))
    })
}
export default ticketSlice.reducer
